import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
import './styles/legacy.css';
import './styles/react-shell.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
